import React, { FC } from 'react'

import { Txt, Icon, ShadedButton } from 'src/components/atoms'

type Props = {
  onClick?: () => void
  className?: string
}

export const AddAllowedIpButton: FC<Props> = ({ onClick, className }) => {
  return (
    <ShadedButton className={className} onClick={onClick}>
      <div className="tw-flex tw-items-center">
        <Icon size="--r1" path="plus/soft/line" />
        <Txt sizeType="s" className="tw-font-bold tw-ml-s-3">
          新規IPアドレス追加
        </Txt>
      </div>
    </ShadedButton>
  )
}
